import { useParams, useNavigate } from 'react-router-dom'
import { Box, Typography, Button, Container } from '@mui/material'
import { IMAGE_BASE_PATH_DBRAIMT } from '../../Config/Config'

const FileViewer = ({ filePath, backButton }) => {
  const { '*': paramPath } = useParams()
  const navigate = useNavigate()

  const decodedPath = filePath
    ? filePath
    : paramPath
    ? paramPath.split('/').map(decodeURIComponent).join('/')
    : ''

  const fileUrl = `${IMAGE_BASE_PATH_DBRAIMT}dbraimt/${decodedPath}`

  const getExtension = (url) => url.split('.').pop().toLowerCase()

  const renderViewer = () => {
    const ext = getExtension(decodedPath)
    const videoExtensions = ['mp4', 'webm', 'ogg', 'mov', 'avi', 'mkv']
    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg']

    if (ext === 'pdf') {
      return (
        <iframe
          src={fileUrl}
          title="PDF Viewer"
          width="100%"
          height="100%"
          style={{ border: 'none' }}
        />
      )
    } else if (ext === 'html' || ext === 'htm') {
      return (
        <iframe
          src={fileUrl}
          title="HTML Viewer"
          width="100%"
          height="100%"
          style={{ border: 'none' }}
        />
      )
    } else if (videoExtensions.includes(ext)) {
      return (
        <video
          controls
          autoPlay
          style={{ width: '100%', height: '100%', maxHeight: '80vh' }}
        >
          <source src={fileUrl} type={`video/${ext}`} />
          Your browser does not support the video tag.
        </video>
      )
    } else if (imageExtensions.includes(ext)) {
      return (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
          }}
        >
          <img
            src={fileUrl}
            alt="Preview"
            style={{
              maxWidth: '100%',
              maxHeight: '100%',
              objectFit: 'contain',
            }}
          />
        </Box>
      )
    } else if (['doc', 'docx', 'xls', 'xlsx'].includes(ext)) {
      const officeUrl = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
        fileUrl
      )}`
      return (
        <iframe
          src={officeUrl}
          title="Office Viewer"
          width="100%"
          height="100%"
          style={{ border: 'none' }}
        />
      )
    } else {
      return (
        <Box>
          <Typography color="error" mb={1}>
            File preview not supported.
          </Typography>
          <a href={fileUrl} target="_blank" rel="noopener noreferrer">
            <Typography color="primary">Click here to download</Typography>
          </a>
        </Box>
      )
    }
  }

  return (
    <Container sx={{ mb: 2, mt: 2 }}>
      <Box sx={{ m: 2 }}>
        <Button
          sx={{ backgroundColor: 'background.mainBackground' }}
          variant="contained"
          onClick={() => navigate(backButton || -1)}
        >
          <i className="fas fa-arrow-left" style={{ paddingRight: '10px' }} />
          Back
        </Button>
      </Box>
      <Box
        sx={{
          px: { xs: 1, sm: 2, md: 4 },
          height: '100vh',
          width: '100%',
          p: 2,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {decodedPath ? (
          <Box sx={{ flexGrow: 1, height: '100%', minHeight: 0 }}>
            {renderViewer()}
          </Box>
        ) : (
          <Typography color="error">Invalid file path</Typography>
        )}
      </Box>
    </Container>
  )
}

export default FileViewer
